export const CITY_CONFIG = {
  Hyderabad: { work: true, stag: true, tagline: "Spice markets to speakeasies.", accent: '#fb923c', emoji: '🌶️' },
  Bengaluru: { work: true, stag: true, tagline: "Build by day, break in by night.", accent: '#f97316', emoji: '⚡' },
  Mumbai: { work: false, stag: true, tagline: "Maximum hustle, midnight waves.", accent: '#f59e0b', emoji: '🌊' },
  Vizag: { work: false, stag: false, tagline: "Harbor mornings, hidden lounges.", accent: '#38bdf8', emoji: '⚓' },
  'Delhi NCR': { work: false, stag: false, tagline: "Power brunch to rooftop scenes.", accent: '#a855f7', emoji: '🛕' },
  Goa: { work: false, stag: false, tagline: "Beach sun, neon sundowners.", accent: '#34d399', emoji: '🌴' },
  Pune: { work: false, stag: false, tagline: "Co-work beats and craft brews.", accent: '#f87171', emoji: '🍻' },
  Kolkata: { work: false, stag: false, tagline: "Adda afternoons, late-night jazz.", accent: '#facc15', emoji: '🎷' },
};

/** IANA zone for local-time Radar copy (India-first; extend per city as you launch regions) */
export const CITY_TIMEZONE = {
  Hyderabad: 'Asia/Kolkata',
  Bengaluru: 'Asia/Kolkata',
  Mumbai: 'Asia/Kolkata',
  Vizag: 'Asia/Kolkata',
  'Delhi NCR': 'Asia/Kolkata',
  Goa: 'Asia/Kolkata',
  Pune: 'Asia/Kolkata',
  Kolkata: 'Asia/Kolkata',
};

export function getCityTimezone(city) {
  if (city && CITY_TIMEZONE[city]) return CITY_TIMEZONE[city];
  return 'Asia/Kolkata';
}

export const CITY_ORDER = [
  'Hyderabad',
  'Bengaluru',
  'Mumbai',
  'Vizag',
  'Delhi NCR',
  'Goa',
  'Pune',
  'Kolkata',
];

/** Approximate city centers for GPS → nearest live market (WGS-84). */
export const CITY_CENTROIDS = {
  Hyderabad: { lat: 17.385, lng: 78.4867 },
  Bengaluru: { lat: 12.9716, lng: 77.5946 },
  Mumbai: { lat: 19.076, lng: 72.8777 },
  Vizag: { lat: 17.6868, lng: 83.2185 },
  'Delhi NCR': { lat: 28.6139, lng: 77.209 },
  Goa: { lat: 15.2993, lng: 74.124 },
  Pune: { lat: 18.5204, lng: 73.8567 },
  Kolkata: { lat: 22.5726, lng: 88.3639 },
};

/** Default market when user is outside `CITY_MAX_DISTANCE_KM` of any centroid. */
export const DEFAULT_GEO_FALLBACK_CITY = 'Hyderabad';

/** Max distance (km) from a centroid to count as "in" that live city for auto-pick. */
export const CITY_MAX_DISTANCE_KM = 240;

export const isWorkCityActive = (city) => Boolean(CITY_CONFIG[city]?.work);
export const isStagCityActive = (city) => Boolean(CITY_CONFIG[city]?.stag);
